import "./BuyerPortal.module.css";
import Header from "@/reusable_sections/Header";
import HeroSection from "./sections/HeroSection";
import RealTimeAnalysis from "./sections/RealTimeAnalysis";
import RequestAccessForm from "./sections/RequestAccessForm";
import Footer from "@/reusable_sections/Footer";
export default function BuyerPortalPage() {
  return <div>
      <Header />
      <HeroSection />
      <RealTimeAnalysis />
      <RequestAccessForm />
      <Footer />
    </div>;
}